import axios from 'axios';
import { getBaseUrl } from '../../config/config';

const loginFunction = {
  login: (data) => new Promise((resolve) => {
    axios.post(`${getBaseUrl()}/auth/`, data).then((response) => {
      if (response.data.login) {
        localStorage.setItem('@session',
          JSON.stringify({ 
            token: response.data.access,
            id: response.data.id,
            username: response.data.username
          }));
        resolve({ login: response.data.login});
      } else {
        resolve({ login: false, message: response.data.message });
      }
    })
  }),
  logout: () => {
    localStorage.clear();
    window.location.href = process.env.REACT_APP_RETURN_LOGIN;
  }
}


export default loginFunction;